export enum DocumentReviewValidationStatus{
    None,
    Info,
    Warnings,
    Error
}